module.exports = __webpack_public_path__ + "img/B - 01.fda41449.png";